import gql from 'graphql-tag'

import { ChildFieldsFragment } from './child'

export const UPSERT_CHILD_MUTATION = gql`
  mutation UpsertChild($child: ChildParams!) {
    upsertChild(child: $child) {
      ...ChildFields
    }
  }

  ${ChildFieldsFragment}
`
